import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_STATES: 'fetchStates'
}

export const globalActions = getNamespacedBy('state', actionTypes)
